(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('play', function(event) {
    if (!(event.target instanceof HTMLVideoElement) || !event.target.matches('.bl-product-video')) return;
    document.querySelectorAll('media-gallery .bl-product-video').forEach(function(video) {
      if (video !== event.target) video.pause();
    });
  }, true);
  document.querySelectorAll('media-gallery').forEach(function(gallery) {
    const pauseHiddenVideos = function() {
      gallery.querySelectorAll('.bl-product-video').forEach(function(video) {
        const slide = video.closest('.splide__slide');
        if (!video.getClientRects().length || (slide && slide.getAttribute('aria-hidden') === 'true')) video.pause();
      });
    };
    new MutationObserver(pauseHiddenVideos).observe(gallery, { attributes: true, subtree: true, attributeFilter: ['aria-hidden', 'class'] });
    window.addEventListener('resize', pauseHiddenVideos);
  });
  } catch(e) { console.error(e); }
})();

})();
